/// <amd-module name="Wit/Common/KanbanBoardSettings/Components/AnnotationSettingsView/AnnotationSettingsInterfaces" />
import { IObservableValue } from "VSS/Core/Observable";

/**
 * Represents values of the tag style setting
 */
export interface IAnnotationSettingsData {
    /**
     * Name of the annotation setting
     */
    name: string;
    /**
     * Indicates if the annotation is enabled
     */
    isEnabled: IObservableValue<boolean>;
    /**
     * Id of the annotation setting
     */
    id: string;
}
